export const privacyPolicyAPI = `${process.env.REACT_APP_API_URL}/landingpagecontent/privacy-policy`;
export const termsOfUseAPI = `${process.env.REACT_APP_API_URL}/landingpagecontent/terms-of-use-home-improvement`;
export const optOutApi = `${process.env.REACT_APP_OLD_API_URL}/api/unsub`;
export const partnerList = `${process.env.REACT_APP_API_URL}/landingpagecontent/tcpa-partners-list-home-improvement`;
export const arbitrateAPI = `${process.env.REACT_APP_API_URL}/landingpagecontent/arbitrate`;
